export default __webpack_public_path__ + "static/media/jul_home.446d6ab5.jpg";